"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSearchPanelStringResources = exports.CommonLabels = exports.SeqCaptionPrefixes = exports.HeaderFooterStringResources = exports.StringResources = void 0;
var StringResources = (function () {
    function StringResources() {
        this.headerFooter = new HeaderFooterStringResources();
        this.seqCaptionPrefixes = new SeqCaptionPrefixes();
        this.commonLabels = new CommonLabels();
        this.quickSearchPanel = new QuickSearchPanelStringResources();
    }
    return StringResources;
}());
exports.StringResources = StringResources;
var HeaderFooterStringResources = (function () {
    function HeaderFooterStringResources() {
    }
    return HeaderFooterStringResources;
}());
exports.HeaderFooterStringResources = HeaderFooterStringResources;
var SeqCaptionPrefixes = (function () {
    function SeqCaptionPrefixes() {
    }
    return SeqCaptionPrefixes;
}());
exports.SeqCaptionPrefixes = SeqCaptionPrefixes;
var CommonLabels = (function () {
    function CommonLabels() {
    }
    return CommonLabels;
}());
exports.CommonLabels = CommonLabels;
var QuickSearchPanelStringResources = (function () {
    function QuickSearchPanelStringResources() {
    }
    return QuickSearchPanelStringResources;
}());
exports.QuickSearchPanelStringResources = QuickSearchPanelStringResources;
